module.exports = __webpack_public_path__ + "img/e3_img2.03ad939.jpg";